import { useEffect, useRef, useState } from "react";
import HeroSplineEmbed from "@/components/sections/hero/HeroSplineEmbed";
import {
  COMPANY_CARD_SPLINE_EMBED_KEY,
  COMPANY_CARD_SPLINE_URL,
  getCompanyHeroCardRenderSize,
} from "@/components/sections/company-v2/companyHeroSpline";

export default function CompanyHeroSplineCards() {
  const frameRef = useRef(null);
  const [renderSize, setRenderSize] = useState(() => getCompanyHeroCardRenderSize(1440, 810));

  useEffect(() => {
    const node = frameRef.current;
    if (!node) return undefined;

    const update = () => {
      const { width, height } = node.getBoundingClientRect();
      setRenderSize(getCompanyHeroCardRenderSize(width, height));
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(node);
    window.addEventListener("orientationchange", update);

    return () => {
      observer.disconnect();
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return (
    <div ref={frameRef} className="ds-company-v2-hero__spline-layer-inner">
      <HeroSplineEmbed
        key={COMPANY_CARD_SPLINE_EMBED_KEY}
        src={COMPANY_CARD_SPLINE_URL}
        stageClassName="ds-company-v2-hero__spline-stage"
        renderWidth={renderSize.width}
        renderHeight={renderSize.height}
        scaleMode="width"
      />
    </div>
  );
}
